import { generateUUID } from "@/business/shared/commons/uuid/uuid";
import { CreateDeliveryRequest, DeliveryActions } from "../domain/deliveries";
import { createDelilveryService } from "../infrastructure/services/createDeliveryService";

export const createDelivery = {
  async execute(
    client: string,
    name: string,
    message: string,
    approvedFiles: string | null,
    rejectedFiles: string | null,
    deliveryDate: string
  ): Promise<void> {
    const request: CreateDeliveryRequest =
      await DeliveryActions().createDeliveryRequest(
        generateUUID(),
        client,
        name,
        message,
        approvedFiles,
        rejectedFiles,
        deliveryDate
      )

    // await createDelilveryService.execute(request);
  },
};
